import styled, { css } from 'styled-components';

import { media } from 'styles/utils';
import Row from 'components/Row';

const FormControlGroup = styled(Row)`
  & > * {
    width: 100%;
    flex-grow: 1;
  }

  ${({ $breakpoint }) =>
    $breakpoint &&
    css`
      ${media.min($breakpoint)} {
        & > * {
          width: unset;
        }

        & > :not(:first-child) {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }

        & > :not(:last-child) {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        & > button,
        input[type='submit'] {
          flex: 0 0 max-content;
        }
      }
    `}
`;

FormControlGroup.defaultProps = {
  breakpoint: 'md',
  colGap: 0,
  layout: 'auto',
  rowGap: '1rem',
};

export default FormControlGroup;
